import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Sardius Group Estate</h3>
            <p>Premium real estate developments for modern living and smart investments.</p>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#estates">Our Estates</a></li>
              <li><a href="#contact">Contact Us</a></li>
              {/* <li><a href="/admin">Admin Panel</a></li> */}
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Contact</h4>
            {/* <p>Website: www.gtextland.com</p> */}
            <p>Follow us: <a href="https://www.instagram.com/jaspergardenia/" target="_blank" rel="noopener noreferrer">@SardiusGroupEstate</a></p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Sardius Group Estate. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

